// @flow
import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import { mediaMin } from 'frontend_core/dist/styles/media'
import LabelRequired from 'components/atoms/LabelRequired'

const FormSectionTitleWrapper = styled.div`
  width: 100%;
`
const TitleContainer = styled.div`
  display: table;
`
const LabelRequiredWrapper = styled.div`
  display: table-cell;
`
const Title = styled.p`
  display: table-cell;
  padding: 1px 0 0 ${spacing.small_2}px;
  font-size: ${fontSize.medium}px;
  vertical-align: middle;
  ${mediaMin.phone`
    font-size: ${fontSize.medium_2}px;
  `};
`
const Description = styled.pre`
  color: ${Colors.gray9};
  margin-top: ${spacing.small_2}px;
  line-height: 1.4;
  font-size: ${fontSize.small}px;
  white-space: pre-wrap;
`

type PropTypes = {
  title?: ?any,
  description?: ?any,
  required?: boolean,
}

export default function FormSectionTitle(props: PropTypes) {
  return (
    <FormSectionTitleWrapper>
      <TitleContainer>
        {props.required !== undefined && (
          <LabelRequiredWrapper>
            <LabelRequired {...props} />
          </LabelRequiredWrapper>
        )}
        <Title {...props}>{props.title}</Title>
      </TitleContainer>
      <Description>{props.description}</Description>
    </FormSectionTitleWrapper>
  )
}



// WEBPACK FOOTER //
// ./src/components/molecules/FormSectionTitle/index.jsx